import { render, staticRenderFns } from "./LittleHeader.vue?vue&type=template&id=71c97b52"
import script from "./LittleHeader.vue?vue&type=script&lang=js"
export * from "./LittleHeader.vue?vue&type=script&lang=js"
import style0 from "./LittleHeader.vue?vue&type=style&index=0&id=71c97b52&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports